import PropTypes from 'prop-types';
import React, { useState, useEffect, useMemo } from "react";
import { useNavigate, useParams } from "react-router-dom";

import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

import TableContainer from '../../components/Common/DataTableContainer';

import { useDispatch, useSelector } from "react-redux";
import { fetchBookingsData } from "../../store/bookings/actions";

const BookingsTable = props => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const { data, loading, error } = useSelector(state => state.Bookings);

    const { id: driverId } = useParams();
    useEffect(() => {
        dispatch(fetchBookingsData(driverId));
      }, [dispatch, driverId]);

    const columns = useMemo(
        () => [
          {
            header: 'Customer',
            accessorKey: 'customer',
            enableColumnFilter: false,
            enableSorting: true,
          },
          {
            header: 'Vehicle',
            accessorKey: 'vehicle',
            enableColumnFilter: false,
            enableSorting: true,
          },
          {
            header: 'Payment Status',
            accessorKey: 'paymentStatus',
            enableColumnFilter: false,
            enableSorting: true,
          },
          {
            header: 'Booking Status',
            accessorKey: 'bookingStatus',
            enableColumnFilter: false,
            enableSorting: true,
          },
          {
            header: 'Amount',
            accessorKey: 'amount',
            enableColumnFilter: false,
            enableSorting: true,
          },
          {
            header: 'Action',
            id: 'action',
            cell: ({ row }) => {
              const bookingId = row.original?.bookingId;
              return (
                <button
                  className="btn btn-sm btn-success"
                  onClick={() => navigate(`/bookings/${bookingId}`)}
                >
                  <i className="mdi mdi-eye"></i> View
                </button>
              );
            }
          }
        ],
        []
      );

    const totalRecords = data?.data?.length ?? 0;
    
    const transformedData = useMemo(() => {
      return data?.data?.map(item => {
          const booking = item.booking || {};
          const customer = item.customer || {};
          const vehicle = item.vehicle || {};

          return {
              bookingId: booking.id,
              customer: customer.name || "N/A",
              vehicle: vehicle.make_name ? `${vehicle.make_name} ${vehicle.license_plate}` : "-",
              paymentStatus: booking.payment_status == 1 ? 'Paid' : 'Pending' || "N/A",
              bookingStatus: booking.status == 1 ? 'Pending' : (booking.status == 2 ? 'Ongoing' : (booking.status == 3 ? 'Arrived' : (booking.status == 4 ? 'Start' : (booking.status == 5 ? 'Complete' : (booking.status == 6 ? 'Cancel' : (booking.status == 7 ? 'Expired' : (booking.status == 8 ? 'Schedule' : (booking.status == 9 ? 'Schedule Accept' : '-')))))))) || "N/A",
              amount: booking.total_amount || "N/A",
          };
      });
    }, [data]);

    return (
    <>
    {loading ? (
        <Skeleton count={10} height={40} />
        ) : (
        <TableContainer
          columns={columns}
          data={transformedData || []}
          isGlobalFilter={true}
          isPagination={true}
          SearchPlaceholder={`Looking for something? ${totalRecords} results loaded.`}
          pagination="pagination"
          paginationWrapper='dataTables_paginate paging_simple_numbers'
          tableClass="table-bordered table-nowrap dt-responsive nowrap w-100 dataTable no-footer dtr-inline"
        />
      )}
      </>
  );
};

BookingsTable.propTypes = {
  t: PropTypes.any
};

export default BookingsTable;